module.exports = __webpack_public_path__ + "71a558e7ad9270b309115c8fae6c5e63.png";